module.exports = __webpack_public_path__ + "static/media/0.a622bec4.jpeg";